const { useEffect, useState } = wp.element;

const Component = ({ bookingData, category, setCategory }) => {
    return (
        <div className="section" id="section-category">
            <div className="container grid">
                <h2 className="section-title">Hva slags behandling ønsker du?</h2>
                <p className="section-description">Velg blant våre mest populære kategorier.</p>

                <div className="items">
                    <div className="container">
                        <button 
                            onClick={() => { setCategory('package') }} 
                            className={`item ${category == 'package' ? 'active' : ''}`} 
                        >
                            <span>
                                <h3 className="item-title">{bookingData?.package?.title}</h3>
                                <p className="item-description">{bookingData?.package?.description}</p>
                            </span>
                        </button>
                        <button 
                            onClick={() => { setCategory('cut') }} 
                            className={`item ${category == 'cut' ? 'active' : ''}`} 
                        >
                            <span>
                                <h3 className="item-title">{bookingData?.cut?.title}</h3>
                                <p className="item-description">{bookingData?.cut?.description}</p>
                            </span>
                        </button>
                        <button 
                            onClick={() => { setCategory('color') }} 
                            className={`item ${category == 'color' ? 'active' : ''}`} 
                        >
                            <span>
                                <h3 className="item-title">{bookingData?.color?.title}</h3>
                                <p className="item-description">{bookingData?.color?.description}</p>
                            </span>
                        </button>
                        <button 
                            onClick={() => { setCategory('men') }} 
                            className={`item ${category == 'men' ? 'active' : ''}`} 
                        >
                            <span>
                                <h3 className="item-title">{bookingData?.men?.title}</h3>
                                <p className="item-description">{bookingData?.men?.description}</p>
                            </span>
                        </button>
                        <button 
                            onClick={() => { setCategory('styling') }} 
                            className={`item ${category == 'styling' ? 'active' : ''}`} 
                        >
                            <span>
                                <h3 className="item-title">{bookingData?.styling?.title}</h3>
                                <p className="item-description">{bookingData?.styling?.description}</p>
                            </span>
                        </button>
                        <button 
                            onClick={() => { setCategory('other') }} 
                            className={`item ${category == 'other' ? 'active' : ''}`} 
                        >
                            <span>
                                <h3 className="item-title">{bookingData?.other?.title}</h3>
                                <p className="item-description">{bookingData?.other?.description}</p>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            
            {
                category &&
                <svg className="progress-arrow" width="64" height="32" viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0H64L32 32L0 0Z" fill="currentColor"/>
                </svg>
            }
        </div>
    )
}

export default Component;